"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalBadge = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const Iconista_1 = require("../../../../icons/Iconista");
const BasicTooltip_1 = require("../../../BasicTooltip");
const OptionalBadge = () => {
    const [t] = (0, use_t_1.useT)();
    return (React.createElement(BasicTooltip_1.BasicTooltip, { renderTooltip: () => t('optional') },
        React.createElement("span", { role: "img", style: { marginInlineStart: 4, opacity: 0.45, verticalAlign: 'middle' }, "aria-label": t('optional') },
            React.createElement(Iconista_1.Iconista, { width: 11, height: 11, set: "tabler", icon: "circle-dashed" }))));
};
exports.OptionalBadge = OptionalBadge;
